document.addEventListener("DOMContentLoaded", function () {
    let bmi05Data = null;
    let bmi519Data = null;
    let whoChart = null;

    Promise.all([
    fetch(window.WHO_BMI05_URL).then(r => r.json()),
    fetch(window.WHO_BMI519_URL).then(r => r.json())
    ])
    .then(([bmi05, bmi519]) => {

        bmi05Data = bmi05;
        bmi519Data = bmi519;

        console.log("WHO datasets loaded");

    })
    .catch(err => console.error(err));

    const age = document.getElementById("bmi-age");
    const height = document.getElementById("bmi-height");
    const weight = document.getElementById("bmi-weight");

    const calculateBtn = document.getElementById("bmi-calculate");
    const resetBtn = document.getElementById("bmi-reset");

    const bmiValue = document.getElementById("bmi-value");
    const bmiCategory = document.getElementById("bmi-category");
    const healthyRange = document.getElementById("healthy-range");
    const advice = document.getElementById("bmi-advice");
    const pointer = document.getElementById("bmi-pointer");

    const modeInputs = document.querySelectorAll('input[name="mode"]');
    const ageField = document.getElementById("age-field");
    const childResult = document.getElementById("child-result");

    ageField.style.display = "none";

    modeInputs.forEach(input => {

    input.addEventListener("change", () => {

            if (input.value === "adult" && input.checked) {
            ageField.style.display = "none";
            childResult.style.display = "none";
            }

            if (input.value === "child" && input.checked) {
            ageField.style.display = "block";
            }

        });

    });

    calculateBtn.addEventListener("click", calculateBMI);
    resetBtn.addEventListener("click", resetBMI);

    function calculateZScore(value, ref){

        const L = ref.L;
        const M = ref.M;
        const S = ref.S;

        if(L===0){

            return Math.log(value/M)/S;

        }

        return (Math.pow(value/M,L)-1)/(L*S);

    }   

    function zToPercentile(z){

        const t = 1/(1+0.2316419*Math.abs(z));

        const d = 0.3989423*Math.exp(-z*z/2);

        let p =
            d*t*
            (
                0.3193815+
                t*(-0.3565638+
                t*(1.781478+
                t*(-1.821256+
                t*1.330274)))
            );

        if(z>0){

            p=1-p;

        }

        return p*100;

    }
    
    function classifyChildBMI(z){

        if(z<-3){

            return{
                category:"Severe Thinness",
                advice:"Consult a pediatrician."
            };

        }

        if(z<-2){

            return{
                category:"Thinness",
                advice:"Below healthy range."
            };

        }

        if(z<=1){

            return{
                category:"Healthy Weight",
                advice:"Healthy BMI-for-age."
            };

        }

        if(z<=2){

            return{
                category:"Risk of Overweight",
                advice:"Monitor nutrition and activity."
            };

        }

        if(z<=3){

            return{
                category:"Overweight",
                advice:"Above WHO healthy range."
            };

        }

        return{

            category:"Obesity",
            advice:"Consult your healthcare provider."

        };

    }

    function generateGrowthCurves(data, gender) {

        const curves = {
            minus3: [],
            minus2: [],
            minus1: [],
            median: [],
            plus1: [],
            plus2: [],
            plus3: []
        };

        const months = Object.keys(data[gender])
            .map(Number)
            .sort((a, b) => a - b);

        months.forEach(month => {

            const ref = data[gender][month];

            const L = ref.L;
            const M = ref.M;
            const S = ref.S;

            function bmiAtZ(z) {

                if (L === 0) {
                    return M * Math.exp(S * z);
                }

                return M * Math.pow(1 + L * S * z, 1 / L);

            }

            curves.minus3.push({
                x: month / 12,
                y: bmiAtZ(-3)
            });

            curves.minus2.push({
                x: month / 12,
                y: bmiAtZ(-2)
            });

            curves.minus1.push({
                x: month / 12,
                y: bmiAtZ(-1)
            });

            curves.median.push({
                x: month / 12,
                y: bmiAtZ(0)
            });

            curves.plus1.push({
                x: month / 12,
                y: bmiAtZ(1)
            });

            curves.plus2.push({
                x: month / 12,
                y: bmiAtZ(2)
            });

            curves.plus3.push({
                x: month / 12,
                y: bmiAtZ(3)
            });

        });

        return curves;

    }

    function calculateBMI(){

        const h = parseFloat(height.value)/100;
        const w = parseFloat(weight.value);
        const mode = document.querySelector('input[name="mode"]:checked').value;
        const userAge = parseInt(age.value);
        const sex = document.querySelector('input[name="sex"]:checked').value;

        if (mode === "child" &&(!bmi05Data || !bmi519Data)){
            alert("WHO growth data is still loading.");
            return;
        }

        if(isNaN(h) || isNaN(w) || h<=0 || w<=0){
            alert("Please enter valid height and weight.");
            return;
        }

        const bmi = w/(h*h);

        bmiValue.innerHTML = bmi.toFixed(1);

        //-----------------------
        // Category
        //-----------------------

        let category = "";
        let message = "";

        // ---------------------
        // Adult Calculator
        // ---------------------
        if (mode === "adult") {

            childResult.style.display = "none";

            if (bmi < 18.5) {
                category = "Underweight";
                message = "You are underweight. Consider increasing your calorie and protein intake.";
            }
            else if (bmi < 25) {
                category = "Healthy Weight";
                message = "Great! Your BMI is in the healthy range.";
            }
            else if (bmi < 30) {
                category = "Overweight";
                message = "A balanced diet and regular exercise may help improve your health.";
            }
            else {
                category = "Obesity";
                message = "Consider consulting a healthcare professional for personalized advice.";
            }

        }

        // ---------------------
        // Child Calculator
        // ---------------------
        else {

            if (isNaN(userAge)) {
                alert("Please enter age.");
                return;
            }

            const month = userAge * 12;
            const genderKey = sex === "male" ? "boys" : "girls";

            let ref;

            // WHO 0–5 years
            if (userAge <= 5) {

                ref = bmi05Data[genderKey][month];

            }
            // WHO 5–19 years
            else if (userAge <= 19) {

                ref = bmi519Data[genderKey][month];

            }
            // Adult
            else {

                alert("Use Adult mode for ages 20 and above.");
                return;

            }

            if (!ref) {
                alert("WHO data not found for this age.");
                return;
            }

            const curves =
            userAge <= 5
                ? generateGrowthCurves(bmi05Data, genderKey)
                : generateGrowthCurves(bmi519Data, genderKey);
                
            drawChart(curves, userAge, bmi);

        console.log(curves);

            const z = calculateZScore(bmi, ref);
            const percentile = zToPercentile(z);

            console.log(ref);
            console.log("BMI:", bmi);
            console.log("Z-score:", z);
            console.log("Percentile:", percentile.toFixed(1));

            childResult.style.display = "block";

            const result = classifyChildBMI(z);

            category = result.category;
            message = result.advice;

            document.getElementById("child-percentile").innerHTML = `
            <div class="child-summary">

            <div><strong>BMI</strong><br>${bmi.toFixed(1)}</div>

            <div><strong>Z-score</strong><br>${z.toFixed(2)}</div>

            <div><strong>Percentile</strong><br>${percentile.toFixed(1)}%</div>

            </div>
            `;

        }

        bmiCategory.innerHTML = category;
        bmiCategory.className = "bmi-category";
        switch(category){
            case "Healthy Weight":
                bmiCategory.classList.add("healthy");
                break;
            case "Risk of Overweight":
                bmiCategory.classList.add("risk");
                break;
            case "Overweight":
                bmiCategory.classList.add("overweight");
                break;
            case "Obesity":
                bmiCategory.classList.add("obese");
                break;
            default:
                bmiCategory.classList.add("underweight");
            }
        advice.innerHTML = message;
        //-----------------------
        // Healthy Weight Range
        //-----------------------

        const min=(18.5*h*h).toFixed(1);
        const max=(24.9*h*h).toFixed(1);

        healthyRange.innerHTML=min+" kg - "+max+" kg";

        //-----------------------
        // Gauge Pointer
        //-----------------------

        let percent=(bmi/40)*100;

        if(percent<2) percent=2;

        if(percent>98) percent=98;

        pointer.style.left=percent+"%";

    }

    function resetBMI(){

        age.value="";
        height.value="";
        weight.value="";

        bmiValue.innerHTML="--";
        bmiCategory.innerHTML="Enter your information";
        healthyRange.innerHTML="--";
        advice.innerHTML="Enter your height and weight to see your result.";

        pointer.style.left="50%";

    }

    function drawChart(curves, age, bmi) {

        const ctx = document.getElementById("whoChart").getContext("2d");

        if (whoChart) {
            whoChart.destroy();
        }

        whoChart = new Chart(ctx, {

            type: "line",

            data: {

                datasets: [

                    {
                        label: "-3 SD",
                        data: curves.minus3,
                        borderColor: "#e74c3c",
                        borderWidth: 1,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "-2 SD",
                        data: curves.minus2,
                        borderColor: "#ff9800",
                        borderWidth: 1,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "-1 SD",
                        data: curves.minus1,
                        borderColor: "#f1c40f",
                        borderWidth: 1,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "Median",
                        data: curves.median,
                        borderColor: "#27ae60",
                        borderWidth: 2,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "+1 SD",
                        data: curves.plus1,
                        borderColor: "#3498db",
                        borderWidth: 1,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "+2 SD",
                        data: curves.plus2,
                        borderColor: "#2980b9",
                        borderWidth: 1,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "+3 SD",
                        data: curves.plus3,
                        borderColor: "#8e44ad",
                        borderWidth: 1,
                        pointRadius: 0,
                        tension: 0.3
                    },

                    {
                        label: "Your Child",

                        type: "scatter",

                        data: [

                            {
                                x: age,
                                y: bmi
                            }

                        ],

                        pointRadius: 8,
                        pointBackgroundColor: "#000",
                        pointBorderColor: "#fff",
                        pointBorderWidth: 2

                    }

                ]

            },

            options: {

                responsive: true,

                scales: {

                    x: {

                        type: "linear",

                        title: {

                            display: true,

                            text: "Age (years)"

                        }

                    },

                    y: {

                        title: {

                            display: true,

                            text: "BMI"

                        }

                    }

                }

            }

        });

    }
});